import type { Observable } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponse } from '../../../../common/models/api-response.interface';
import { APP_SETTINGS } from '../../app-settings';
import { RbacUserPermissions } from '../../../../common/models/rbac.interface';

@Injectable()
export class UserPermissionsService {
    constructor(
        private http: HttpClient,
        @Inject(APP_SETTINGS) private appSettings
    ) {}

    getRbacUserPermissions(): Observable<ApiResponse<RbacUserPermissions>> {
        return this.http.get<ApiResponse<RbacUserPermissions>>(
            `${this.appSettings.apiEndpoint}rbacUserPermissions`
        );
    }
}
